import React from 'react';
import SEO from './SEO';
import { PAGE_SEO } from '../utils/seoConfig';
import './Legal.css';

const PrivacyPolicy = () => {
  const seo = PAGE_SEO['/privacy'];
  return (
    <div className="legal-container">
      <SEO
        title={seo.title}
        description={seo.description}
        canonical="/privacy"
        robots={seo.robots}
      />
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>
      
      <section>
        <h2>1. Information We Collect</h2>
        <h3>1.1 Personal Information</h3>
        <p>When you use FreshFitLab, we collect:</p>
        <ul>
          <li>Account information (name, email) when you sign in with Google</li>
          <li>User preferences and interactions (likes, recipe views)</li>
          <li>Device information and IP address</li>
        </ul>

        <h3>1.2 Photos and Camera Access</h3>
        <p>Our mobile application may request access to your device's camera and photo library. This access is used to:</p>
        <ul>
          <li>Upload photos of recipes you create or discover to associate with your personal menus and recipes</li>
          <li>Capture images of dishes directly from your device's camera for use in your recipe collection</li>
        </ul>
        <p><strong>How images are stored and shared:</strong></p>
        <ul>
          <li>Images you upload are stored securely on our servers and associated with your account</li>
          <li>Public-facing recipe images are moderated by a site administrator before being visible to other users</li>
          <li>We do not sell, share, or distribute your uploaded images to third parties</li>
          <li>Video capture is not used by this application</li>
        </ul>

        <h3>1.3 Usage Information</h3>
        <p>We automatically collect information about how you use FreshFitLab, including:</p>
        <ul>
          <li>Pages you visit</li>
          <li>Actions you take (likes, searches)</li>
          <li>Time spent on pages</li>
        </ul>
      </section>

      <section>
        <h2>2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Provide and improve our services</li>
          <li>Personalize your experience</li>
          <li>Send important notifications</li>
          <li>Analyze usage patterns</li>
          <li>Prevent fraud and abuse</li>
        </ul>
      </section>

      <section>
        <h2>3. Information Sharing</h2>
        <p>We do not sell your personal information. We may share your information with:</p>
        <ul>
          <li>Service providers who assist in operating our platform</li>
          <li>Law enforcement when required by law</li>
          <li>Other users (only your public profile information)</li>
        </ul>
      </section>

      <section>
        <h2>4. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal information</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Opt-out of certain data collection</li>
        </ul>
      </section>

      <section>
        <h2>5. Contact Us</h2>
        <p>If you have questions about this Privacy Policy, please contact us at:</p>
        <p>Email: privacy@freshfitlab.io</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy; 